import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { AppService } from './app.service';
import { ApplicationInsightsService } from './application-insights.service';
import { AccessTokenService } from './services/access-token.service';
import { ContentService } from './services/content.service';
import { DescriptionService } from './services/description.service';
import { GoogleAnalyticsService } from './services/google-analytics.service';
import { IntroductionService } from './services/introduction.service';
import { TeamReportService } from './services/team-report.service';
import { TypeDescriptionReportService } from './services/type-description-report.service';
import { sessionInterceptor } from './common/http-interceptors/session.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(appRoutes),
    provideHttpClient(withInterceptors([sessionInterceptor])),
    provideAnimations(),
    AppService,
    ApplicationInsightsService,
    DescriptionService,
    IntroductionService,
    ContentService,
    GoogleAnalyticsService,
    TypeDescriptionReportService,
    AccessTokenService,
    TeamReportService,
  ],
};
